// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| ADMINISTRACION MENU ITEMS ||============================== //

const administracion = {
    id: 'administracion',
    title: 'Administracion',
    type: 'group',
    children: [
        {
            id: 'empresas',
            title: 'Empresas',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'lista_empresa',
                    title: 'Lista Empresas',
                    type: 'item',
                    url: '/company/list-company-admin'
                },
                {
                    id: 'nueva_empresa',
                    title: 'Nueva Empresa',
                    type: 'item',
                    url: '/company/new-company/0'
                },                
            ]
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'lista_usuarios',
                    title: 'Lista usuarios generales',
                    type: 'item',
                    url: '/user/list-user-admin'
                },
                {
                    id: 'nuevo_usuario',
                    title: 'Nuevo usuario general',
                    type: 'item',
                    url: '/user/new-user/0'
                },                
            ]
        },
        {
            id: 'versiones',
            title: 'Versiones',
            type: 'collapse',
            icon: icons.IconCalendar,
            children: [
                {
                    id: 'lista_versiones',
                    title: 'Lista Versiones',
                    type: 'item',
                    url: '/superadmin/list-versions'
                },
                {
                    id: 'nueva_version',
                    title: 'Nueva Versión',
                    type: 'item',
                    url: '/superadmin/new-version/0'
                },
            ]
        },
        {
            id: 'reportes_generales',
            title: 'Reportes Generales',
            type: 'collapse',
            icon: icons.IconNfc,
            children: [
                {
                    id: 'lista_reportes_generales',
                    title: 'Lista Reportes Generales',
                    type: 'item',
                    url: '/superadmin/list-reportes-generales'
                },
                {
                    id: 'nuevo_reporte_general',
                    title: 'Nuevo Reporte General',
                    type: 'item',
                    url: '/superadmin/new-reporte-general/0'
                },
            ]
        },
    ]
};

export default administracion;
